import { SET_EMAIL_VERIFICATION_STATE } from 'constants/ActionTypes';

export const closeEmailVerificationNotification = (dispatch, getState) =>
    dispatch({
        type: SET_EMAIL_VERIFICATION_STATE,
        state: {
            ...getState().app.emailVerificationState,
            isClosedNotification: true,
        },
    });
